<template>
    <div class="vue-slider-navigation">
        <button class="slider-previous" @click="$emit('slider-previous')">
            <span class="chevron-left"></span>
        </button>

        <button class="slider-next" @click="$emit('slider-next')">
            <span class="chevron-right"></span>
        </button>
    </div>
</template>

<script>
export default {
    name: "SliderNavigation"
}
</script>